import { render, staticRenderFns } from "./LightRefractionViz.vue?vue&type=template&id=6e678898&scoped=true"
import script from "./LightRefractionViz.vue?vue&type=script&lang=js"
export * from "./LightRefractionViz.vue?vue&type=script&lang=js"
import style0 from "./LightRefractionViz.vue?vue&type=style&index=0&id=6e678898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e678898",
  null
  
)

export default component.exports